module.exports = __webpack_public_path__ + "img/872F2D_AB403E_682421_581F1C-256px.163a160e.png";